export default __webpack_public_path__ + "static/media/info-circle.cffd9706.svg";